/**
 * Organisations (plateforme) — branché sur /api/admin/organisations.
 */
import { useEffect, useState } from 'react';
import { appelerApi } from '../../reseau.ts';
import { Badge, PageTitle, Table } from '../ui.tsx';

type Organisation = {
  id: string;
  nom: string;
  slug: string;
  formule: string;
  cree_le: string;
  evenements: string;
  participants: string;
};

export function Organisations() {
  const [organisations, setOrganisations] = useState<Organisation[]>([]);

  useEffect(() => {
    void appelerApi<{ organisations: Organisation[] }>('/api/admin/organisations').then((r) => {
      if (r.donnees) setOrganisations(r.donnees.organisations);
    });
  }, []);

  return (
    <>
      <PageTitle
        title="Organisations"
        subtitle="Toutes les organisations de la plateforme — formule, événements et participants."
      />
      <Table head={['Organisation', 'Formule', 'Événements', 'Participants', 'Créée le']}>
        {organisations.map((o) => (
          <tr key={o.id}>
            <td className="text-blanc">{o.nom}</td>
            <td>
              <Badge filled={o.formule !== 'gratuit'}>{o.formule.replace('_', ' ')}</Badge>
            </td>
            <td className="text-blanc">{o.evenements}</td>
            <td className="text-blanc">{o.participants}</td>
            <td className="text-fumee">
              {new Date(o.cree_le).toLocaleDateString('fr-BE', { day: 'numeric', month: 'short', year: 'numeric' })}
            </td>
          </tr>
        ))}
      </Table>
    </>
  );
}
